import { relayStylePagination } from '@apollo/client/utilities'

export const apolloRelayStylePagination = (args: string[] = []) => {
  const uniqueArgs = [...new Set([...args, 'filters', 'sorts'])]
  return relayStylePagination(uniqueArgs)
}
